let colorStyle = { color: '#FA4B54' }

export default function useGetCheckBillAmountText(displayData) {
  return {
    amountInfoText: (
      <p
        style={{
          textAlign: 'right',
          margin: '20px 0',
          fontSize: '16px'
        }}>
        共 <span style={colorStyle}>{displayData.checkProductTypeNum}</span>{' '}
        种商品，调出总量{' '}
        <span style={colorStyle}>{displayData.totalQuantity}</span> 调出总额
        <span style={colorStyle}>
          {displayData.totalCostPrice !== undefined &&
            Math.abs(displayData.totalCostPrice)}
        </span>
        元
      </p>
    )
  }
}
